<template>
    <ul class="tabs">
        <li 
            :class="{ 
                active: s.isActive, 
                first_item: s.index === 0, 
                last_item: s.index === slotsList.length - 1
            }"
            class="tabs__item"
            @click="slotHandler(i)" 
            v-for="(s, i) in slotsList" 
            :key="i"
        >
            <slot :name="`slot${s.index + 1}`" />
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        tabsCount: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            slotsList: Array(this.$props.tabsCount).fill(1).map((e, i) => ({ index: e * i, isActive: i === 0 }))
        }
    },
    methods: {
        slotHandler(index) {
            this.slotsList = this.slotsList.map((e, i) => ({...e, isActive: index === i}))
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.tabs
    display: flex
    padding: 0
    margin: 0
    &__item
        button
            @include tile-button
            border-radius: 0
            padding: 0 6px
            font-size: 11px
            font-family: Helvetica, Arial, Tahoma, sans-serif
            font-weight: 300
            line-height: 18px
        &.first_item
            button
                border-radius: 4px
                border-top-right-radius: 0
                border-bottom-right-radius: 0
        &.last_item
            button
                border-radius: 4px
                border-top-left-radius: 0
                border-bottom-left-radius: 0
    .active
        button
            color: #cbc7cd
            background-color: #f5f5f5
            border-color: rgba(0,0,0,.2)
            border-top-color: rgba(0,0,0,.3)
            background-image: none
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, .1)
            cursor: default
</style>